<div class="new-modal">
  <div class="title__wrapper mb-4">
    <span class="title">{{ 'Projects.newTaskGroupTitle' | translate }}</span>
    <svg-icon class="clear-icon" src="/assets/img/close-icon.svg" (click)="cancel()"></svg-icon>
  </div>

  <div mat-dialog-content>
    <input-label [label]="'Projects.newTaskGroupName' | translate" [required]="true"></input-label>
    <input-v2
      [formControl]="group"
      [placeholder]="'Projects.newTaskGroupName' | translate"
      (keydown.enter)="submit()"
    ></input-v2>
  </div>
  <mat-dialog-actions class="mb-0 pb-0">
    <div class="d-flex align-items-center justify-content-end w-100 flex-wrap">
      <app-button
        *ngIf="data.edit"
        (onClick)="onRemoveGroup()"
        class="bold mr-2"
        [config]="{
          size: ButtonSize.SMALL,
          type: ButtonTypes.DANGER_BUTTON,
          text: 'Projects.removeGroup' | translate
        }"
      ></app-button>

      <app-button
        (onClick)="cancel()"
        class="bold mr-2"
        [config]="{
          size: ButtonSize.SMALL,
          type: ButtonTypes.NEW_SECONDARY_BLUE,
          text: 'Projects.discard' | translate
        }"
      ></app-button>

      <app-button
        [loading]="loading"
        (onClick)="submit()"
        [config]="{
          size: ButtonSize.SMALL,
          type: ButtonTypes.NEW_PRIMARY_BLUE,
          text: 'Projects.saveAndEnd' | translate
        }"
      ></app-button>
    </div>
  </mat-dialog-actions>
</div>
